// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCoZLbcUeUFH_WnrrfGhKSQHD6azbD1gFU",
  authDomain: "qubright-d5eae.firebaseapp.com",
  projectId: "qubright-d5eae",
  storageBucket: "qubright-d5eae.firebasestorage.app",
  messagingSenderId: "1081615216032",
  appId: "1:1081615216032:web:6c75eae6b09e201b8048c5",
  measurementId: "G-QJVSX6NQN9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;
export const auth = getAuth(app);
export const db = getFirestore(app);
